import { z } from 'zod';

export const IncomeTypeSchema = z.object({
  _id: z.string().optional(),
  name: z.string().min(1, 'Name is required').max(100),
  description: z.string().max(500).optional(),
  isActive: z.boolean().default(true),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type IncomeType = z.infer<typeof IncomeTypeSchema>;

export const CreateIncomeTypeSchema = IncomeTypeSchema.omit({
  _id: true,
  createdAt: true,
  updatedAt: true,
});

export type CreateIncomeType = z.infer<typeof CreateIncomeTypeSchema>;

export const UpdateIncomeTypeSchema = CreateIncomeTypeSchema.partial();

export type UpdateIncomeType = z.infer<typeof UpdateIncomeTypeSchema>;
